<template>
  <v-container>
    <v-row
      align="center"
      justify="center">
      <v-col 
        xs="10"
        sm="8"
        md="5"
        lg="4"
      >
        <h2>Connectez-vous</h2>
        <form>

          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            label="Adresse e-mail"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
            @keyup.enter="submit"
            style="margin-left: 0; margin-right: 0;"
          ></v-text-field>

          <v-text-field
            v-model="password"
            :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="passwordErrors"
            :type="showPw ? 'text' : 'password'"
            label="Mot de passe"
            @click:append="showPw = !showPw"
            required
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @keyup.enter="submit"
            style="margin-left: 0; margin-right: 0;"
          ></v-text-field>

          <router-link 
            :to="{ name: 'ResettingCheckEmail' }"
            style="text-decoration: none;"
          >Mot de passe oublié ?</router-link>

          <v-btn 
            class="success float-right" 
            @click="submit"
          >
            <v-icon 
              class="mr-2"
              style="font-size: 13px;"
            >
              mdi-lock-open
            </v-icon>
            Se connecter
          </v-btn>
        </form>
        <span class="red-text">{{ loginErrors }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // LIBRARY
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_REQUEST } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'

  export default {
    name: 'Login',

    mixins: [validationMixin],

    data: () => ({
      email: '',
      password: '',
      dialog: false,
      showPw: false,
      loginErrors: '',
    }),

    validations: {
      email: { required, email },
      password: { required },
    },

    methods: {
      submit () {
        this.loginErrors = ''
        this.dialog      = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = ''
        } else {
          this.login()
        }
      },
      login() {
        EventBus.$emit(LOADING, 'Connexion...')
        const { email, password } = this
        this.$store.dispatch(AUTH_REQUEST, { email, password }).then(() => {
          EventBus.$emit(LOADED)
          let routeName = 'ListReference'
          if (this.$store.getters.isAdmin && !this.$store.getters.hasCustomer) {
            routeName = 'ChooseCustomer'
          }
          this.$router.push({
            name: routeName,
          })
        }).catch(error => {
          if (error.response) {
            this.loginErrors = error.response.data.error
          } else if (error.request) {
            this.loginErrors = error.request
          } else {
            this.loginErrors = error.message
          }
          EventBus.$emit(LOADED)
        })
      }
    },

    computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Adresse email incorrecte')
        !this.$v.email.required && errors.push('Veuillez renseigner une adresse email')
        return errors
      },
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Veuillez renseigner un mot de passe')
        return errors
      },
    },

    mounted() {
      EventBus.$emit(LOADED)
    }
  }
</script>

<style scoped>
  .red-text {
    color: red;
  }
  .login-logo {
    width: 100px;
    height: 100px;
  }
  .login-container {
    height: 500px;
  }

  @media (min-width: 900px) {
    .login-logo {
      width: 200px;
    }
    .login-container {
      height: 600px;
    }
  } 
</style>